import ApiUtils from "api/Utils";
import EventsActions from "events/EventsEmitter";
import { hexToRgb, rgbToArray } from "services/UtilsService";
import { handleLayerEvent } from "actions/ViewerTools";
import { getCachedData } from "api/Cache";
import { updateData } from "services/CacheService";
import { ImageProperties } from "constants/Raster";
import ViewerEvents from "events/ViewerEvents";
import { handleLayers, findElement, addToCurrentProject } from "./ViewerTools";
import { Errors } from "constants/ui";
import { ViewerActions } from ".";

export default class RasterActions extends EventsActions {
    static views: any = getCachedData("views");
    static selected: string = "";
    static raster: any;
    static draggedRaster: string = "";
    static imageProperties: any = [];

    static getView() {
        if (RasterActions.views.length === 0) {
            RasterActions.views = getCachedData("views");
        }
        var viewId = window.location.pathname.substr(window.location.pathname.lastIndexOf("/") + 1);
        //console.log('RasterActions.viewId:', viewId);
        return RasterActions.views[viewId];
    }

    static setSelected(raster: any) {
        RasterActions.selected = raster !== null ? raster.ID : raster;
        RasterActions.emit("setRaster", raster);
    }

    static getRasters(layer: any, ignoreParent: boolean) {
        var rastersList: any = [];
        if (layer && layer["raster_list"]) {
            var list: any = layer["raster_list"].split(" ");
            var { projectId } = ViewerEvents;
            list.forEach((rasterId: string) => {
                var raster = findElement(projectId, rasterId);
                if (raster && Object.getOwnPropertyNames(raster).length > 0) {
                    if (ignoreParent) {
                        if (!raster["parent"] && raster["view_type"] !== "rasterSet") {
                            rastersList.push(raster);
                        }
                    } else {
                        rastersList.push(raster);
                    }
                }
            });
        }
        return rastersList;
    }

    static getRasterSets(layer: any) {
        var rastersList: any = this.getRasters(layer, true);
        if (layer && layer["raster_list"]) {
            var list: any = layer["rasterset_list"].split(" ");
            var { projectId } = ViewerEvents;
            list.forEach((rasterId: string) => {
                var raster = findElement(projectId, rasterId);
                if (raster && Object.getOwnPropertyNames(raster).length > 0) {
                    rastersList.push(raster);
                }
            });
        }
        return rastersList;
    }

    static addRaster(rasterEntity: any, parent: any, done: any) {
        var view = ViewerEvents.view;
        const projectId = view.project;
        var rasterSetObject: any;
        var pending = 0;
        const compositeRasterSets: any = [];

        const createRaster = (rasterEntity: any, parent: any, done: any) => {
            ApiUtils.serverCreateId((rasterId: string) => {
                if (rasterId !== null) {
                    var isRasterSet: boolean = rasterEntity["file_type"] === "ORTHOSET";
                    var isHeatmap: boolean = rasterEntity["ortho_type"] === "heatmap";
                    let rasterObject: any = {
                        ID: rasterId,
                        file_date: new Date().getTime() + "",
                        file_folder: rasterEntity["file_folder"] || "0",
                        file_type: "VIEW",
                        name: rasterEntity.name,
                        project: projectId,
                        state: "COMPLETE",
                        type: "FILE",
                        view_type: isRasterSet ? "rasterSet" : "raster",
                        view_ref: view.ID,
                        raster_ref: rasterEntity.ID,
                        grayscale: isHeatmap ? "1" : "0",
                    };
                    if (typeof rasterEntity["sdp_sdr_id"] !== "undefined") {
                        rasterObject["sdp_sdr_id"] = rasterEntity["sdp_sdr_id"];
                    }
                    if (typeof rasterEntity["sdp_sdr_version"] !== "undefined") {
                        rasterObject["sdp_sdr_version"] = rasterEntity["sdp_sdr_version"];
                    }
                    if (typeof rasterEntity["sdp_sdr_data_type"] !== "undefined") {
                        rasterObject["sdp_sdr_data_type"] = rasterEntity["sdp_sdr_data_type"];
                    }
                    if (parent) {
                        rasterObject["parent"] = parent.ID;
                    }
                    if (rasterEntity["file_type"] === "ORTHOSET") {
                        rasterSetObject = { ...rasterObject };
                        rasterSetObject["ortho_list"] = rasterEntity["raster_list"];
                        var rastersList = rasterEntity["raster_list"].split(" ");
                        pending = rastersList.length;
                        rastersList.forEach((rasterEntityId: string) => {
                            var rasterEntity = findElement(projectId, rasterEntityId);
                            if (rasterEntity) {
                                createRaster(rasterEntity, rasterSetObject, (curRaster: any) => {
                                    pending--;
                                    compositeRasterSets.push(curRaster);
                                    if (pending === 0) {
                                        var rasterIds = compositeRasterSets.map((raster: any) => {
                                            return raster.ID;
                                        });
                                        rasterSetObject["raster_list"] = rasterIds.join(" ");
                                        addToCurrentProject(rasterSetObject);
                                        done(rasterSetObject);
                                    }
                                });
                            }
                        });
                    }
                    addToCurrentProject(rasterObject);
                    updateData("create", "entities", projectId, rasterObject);

                    if (rasterEntity["file_type"] !== "ORTHOSET") {
                        done(rasterObject);
                    }
                } else {
                    EventsActions.emit("showError", { message: Errors.ERROR_SERVER });
                }
            });
        };

        createRaster(rasterEntity, parent, done);
    }

    static deleteRaster(rasterObject: any, layerId: string, done: any) {
        var rasterId = rasterObject["ID"];
        var orthoRef = rasterObject["raster_ref"];
        console.log(
            "RasterActions.deleteRaster:rasterId:",
            rasterId,
            "| orthRef:",
            orthoRef,
            " from layerId:",
            layerId
        );

        const cleanCache = () => {
            var view = RasterActions.getView();
            if (view && RasterActions.imageProperties[rasterId]) {
                delete RasterActions.imageProperties[rasterId];
                const projectId = view.project;
                updateData("delete", "entities", projectId, rasterObject);
            }
        };

        const cleanCompositeRasters = () => {
            const { viewMetaData, compositeRasters } = ViewerActions;
            var compositeRaster = compositeRasters[layerId];
            if (compositeRaster) {
                var index = compositeRaster.findIndex((raster: any) => raster.ID === orthoRef);
                if (index > -1) {
                    delete compositeRaster[index];
                }
            }
            const layer = viewMetaData[layerId];
            if (layer) {
                layer.components.forEach((component: any, index: number) => {
                    if (component["sourceId"] === rasterId) {
                        layer.components.splice(index, 1);
                    }
                });
            }
        };

        const handleDeleteRaster = (layer: any) => {
            var raster_list = layer["raster_list"];
            raster_list = raster_list.replace(rasterId, "");
            layer["raster_list"] = raster_list.trim();
            var ortho_list = layer["ortho_list"];
            ortho_list = ortho_list.replace(orthoRef, "");
            layer["ortho_list"] = ortho_list.trim();
            cleanCompositeRasters();
            cleanCache();
            handleLayerEvent("refreshView", null, layer);
        };

        var layers = ViewerEvents.getLayers();
        Object.values(layers).forEach((layer: any) => {
            if (layer.ID === layerId) {
                handleDeleteRaster(layer);
            }
        });
        handleLayers(layers);
        done();
    }

    static getImageProperties(raster: any) {
        var visible = raster["visible"] ? (raster["visible"] === "1" ? true : false) : ImageProperties.visible;
        var transparency = raster["transparency"] ? parseFloat(raster["transparency"]) : ImageProperties.transparency;
        var grayscale = raster["grayscale"] ? (raster["grayscale"] === "1" ? true : false) : ImageProperties.grayscale;
        var contrast = raster["contrast"] ? parseFloat(raster["contrast"]) : ImageProperties.contrast;
        var brightness = raster["brightness"] ? parseFloat(raster["brightness"]) : ImageProperties.brightness;
        var gamma = raster["gamma"] ? parseFloat(raster["gamma"]) : ImageProperties.gamma;
        var blendMode =
            typeof raster["blend_mode"] !== "undefined" ? parseInt(raster["blend_mode"]) : ImageProperties.blendMode;
        var blendMakeColorTransparent =
            typeof raster["blend_transparent"] !== "undefined"
                ? raster["blend_transparent"] === "1"
                    ? true
                    : false
                : ImageProperties.blendMakeColorTransparent;
        var blendInvertSelection =
            typeof raster["blend_invert"] !== "undefined"
                ? raster["blend_invert"] === "1"
                    ? true
                    : false
                : ImageProperties.blendInvertSelection;
        var blendTransparentColor =
            typeof raster["transparentColor"] !== "undefined"
                ? rgbToArray(hexToRgb(raster["transparentColor"]))
                : ImageProperties.blendTransparentColor;
        var blendSelectionTolerance =
            typeof raster["blend_selection_tolerance"] !== "undefined"
                ? parseFloat(raster["blend_selection_tolerance"])
                : ImageProperties.blendSelectionTolerance;
        var blendOutputTransparency =
            typeof raster["blend_output_transparency"] !== "undefined"
                ? parseFloat(raster["blend_output_transparency"])
                : ImageProperties.blendOutputTransparency;
        var outputColor = [...ImageProperties.blendOutputColor];
        outputColor.splice(outputColor.length - 1);
        outputColor = [...outputColor, blendOutputTransparency];
        var blendOutputColor =
            typeof raster["outputColor"] === "string"
                ? rgbToArray(hexToRgb(raster["outputColor"]), blendOutputTransparency)
                : outputColor;
        var bands = raster["rgb_bands"]
            ? [parseInt(raster["rgb_bands"][0]), parseInt(raster["rgb_bands"][1]), parseInt(raster["rgb_bands"][2]), 3]
            : ImageProperties.bands;
        var imageProperties = {
            visible: visible,
            transparency: transparency,
            grayscale: grayscale,
            contrast: contrast,
            brightness: brightness,
            gamma: gamma,
            blendMode: blendMode,
            blendMakeColorTransparent: blendMakeColorTransparent,
            blendInvertSelection: blendInvertSelection,
            blendTransparentColor: blendTransparentColor,
            blendSelectionTolerance: blendSelectionTolerance,
            blendOutputTransparency: blendOutputTransparency,
            blendOutputColor: blendOutputColor,
            bands: bands,
        };
        RasterActions.imageProperties[raster.ID] = imageProperties;
        return imageProperties;
    }

    static updateRaster(rasterObject: any, done?: any) {
        var view = RasterActions.getView();
        if (view) {
            const projectId = view.project;
            updateData("updateEntity", "entities", projectId, rasterObject);
        }
        if (done) {
            done();
        }
    }

    static updateImageProperies(layer: any, raster: any, name: string, value: any) {
        var imageProperties: any = { ...RasterActions.getImageProperties(raster) };
        imageProperties[name] = value;
        RasterActions.imageProperties[raster.ID] = imageProperties;
        RasterActions.updateRaster(raster);
        handleLayerEvent(
            "setImagePropertiesAt",
            {
                ...imageProperties,
                image: raster,
            },
            layer
        );
    }

    static setVisibility(layer: any, raster: any, isVisible: boolean) {
        raster["visible"] = isVisible ? "1" : "0";
        RasterActions.getImageProperties(raster);
        handleLayerEvent(
            "setImagePropertiesAt",
            {
                ...RasterActions.imageProperties[raster.ID],
                image: raster,
                visible: isVisible,
            },
            layer
        );

        RasterActions.updateRaster(raster);
        RasterActions.emit("update", raster);
    }

    static setTransparency(layer: any, raster: any, opacity: number) {
        raster["transparency"] = opacity + "";
        RasterActions.getImageProperties(raster);
        handleLayerEvent(
            "setImagePropertiesAt",
            {
                ...RasterActions.imageProperties[raster.ID],
                image: raster,
                transparency: opacity,
            },
            layer
        );
        RasterActions.updateRaster(raster);
        RasterActions.emit("update", raster);
    }
}
